<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">武侠管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>结算列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-switch
          active-color="#13ce66"
          @change="handleSwitchChange()"
          :value="isSwitchOn"
          active-text="开启 批量转账开关"
          inactive-text="关闭"
        ></el-switch>
      </div>
      <br />
      <div class="page-actions">
        <el-input
          placeholder="请输入结算ID"
          clearable
          v-model="filter.settleId"
        ></el-input>
        <el-input
          placeholder="请输入用户ID"
          clearable
          v-model="filter.userId"
        ></el-input>
        <el-select v-model="filter.type" placeholder="请选择类型">
          <el-option value>请选择</el-option>
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select v-model="filter.status" placeholder="请选择状态">
          <el-option value>请选择</el-option>
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <!-- <create @refresh="getRecordList"></create> -->
      </div>
      <el-table :data="list">
        <el-table-column prop="userId" label="用户ID"></el-table-column>
        <el-table-column prop="settleId" label="结算ID"></el-table-column>
        <el-table-column prop="type" label="类型">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.type === 'LEAGUE_ANNUAL'"
              >锁仓利息</el-tag
            >
            <el-tag type="danger" v-if="scope.row.type === 'LEAGUE_BONUS'"
              >锁仓分红</el-tag
            >
            <el-tag type="info" v-if="scope.row.type === 'LEAGUE_INVITE_PROFIT'"
              >推荐人奖励</el-tag
            >
            <el-tag
              type="default"
              v-if="scope.row.type === 'LEAGUE_OWNER_PROFIT'"
              >掌门奖励</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="sum" label="总量"></el-table-column>
        <el-table-column prop="coinType" label="币种"></el-table-column>
        <el-table-column prop="settleTime" label="结算时间">
          <template slot-scope="scope">
            {{ scope.row.settleTime | moment }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="info">未转账</el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="success"
              >成功</el-tag
            >
            <el-tag v-else-if="scope.row.status === 2" type="danger"
              >失败</el-tag
            >
            <el-tag v-else-if="scope.row.status === 3" type="warning"
              >超时</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="small" @click="selectRecord = scope.row"
              >查看详情</el-button
            >
            <el-button
              type="danger"
              v-if="scope.row.status === 0"
              size="small"
              @click="doTransaction(scope.row.id)"
              >转账</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handleCurrentChange"
      ></pagination>
    </el-card>
    <detail-list
      :record="selectRecord"
      @close="selectRecord = null"
    ></detail-list>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Pagination from 'components/pagination';
import DetailList from './components/DetailList';

export default {
  name: 'leagueSettleRecord',
  data() {
    return {
      filter: {
        settleId: '',
        type: '',
        status: ''
      },
      selectRecord: null,
      types: [
        {
          value: 'LEAGUE_ANNUAL',
          label: '锁仓利息'
        },
        {
          value: 'LEAGUE_BONUS',
          label: '锁仓分红'
        },
        {
          value: 'LEAGUE_INVITE_PROFIT',
          label: '推荐人奖励'
        },
        {
          value: 'LEAGUE_OWNER_PROFIT',
          label: '掌门奖励'
        }
      ],
      statusList: [
        { value: 0, label: '未转账' },
        {
          value: 1,
          label: '成功'
        },
        {
          value: 2,
          label: '失败'
        },
        {
          value: 3,
          label: '超时'
        }
      ]
    };
  },
  components: {
    Pagination,
    DetailList
  },
  computed: {
    ...mapState('leagueSettleRecord', [
      'list',
      'pagination',
      'totalCount',
      'isSwitchOn'
    ])
  },
  methods: {
    ...mapActions('leagueSettleRecord', [
      'getList',
      'transaction',
      'transactionSwitch',
      'getTransactionSwitch'
    ]),
    getRecords(data = {}) {
      this.getList({ ...this.pagination, ...this.filter, ...data });
    },
    handleCurrentChange(pagination) {
      this.getRecords(pagination);
    },
    handleSwitchChange() {
      this.transactionSwitch(!this.isSwitchOn).then(() => {
        this.getTransactionSwitch();
      });
    },
    handleSearch() {
      this.getRecords({ page: 1 });
    },
    doTransaction(settleId) {
      this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.transaction(settleId).then(res => {
            //  this.$message({
            //   message: "操作成功!",
            //   type: "success"
            // });
            // this.dialogVisible = false;
            this.getRecords();
          });
        }
      );
    }
  },
  created() {
    if (this.$route.query.settleId) {
      this.filter.settleId = this.$route.query.settleId;
    }
    this.getRecords();
    this.getTransactionSwitch();
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
